import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCvsAction } from "./actions";
import { updateLead } from "./services";
import UploadCv from "./cvUpload";
import UpdateCvDialog from "./updateCv";
import Dashboard from "./cvAnalytics";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  FormControlLabel,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  TextField,
  Checkbox,
} from "@mui/material";
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';


import { createTheme, ThemeProvider } from "@mui/material/styles";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { set } from "date-fns";

// CSS Styles
const floatingButtonStyles = {
  position: "fixed",
  bottom: "16px",
  right: "16px",
  zIndex: 999,
};

const customTheme = createTheme({
  // Add styles specific to the Cvs.js file
  tableContainer: {},
  tableHead: {
    background: "#0089C4",
  },
  tableHeadCell: {
    fontWeight: "bold",
    color: "#ffffff",
    background: "#0089C4",
    fontSize: 4,
  },
  tableRow: {
    "&:hover": {},
  },
});

const Cvs = () => {
  const dispatch = useDispatch();
  const { loading, cvs, error } = useSelector((state) => state.cv);

  const [action, setAction] = useState("");
  const [cvId, setLeadId] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);

  const [filter, setFilter] = useState(""); // State for filter value


  const handleOpenUploadDialog = () => {
    setUploadDialogOpen(true);
  };

  const handleCloseUploadDialog = () => {
    setUploadDialogOpen(false);
  };

  
  useEffect(() => {
    // Check if cvs are not fetched yet
    dispatch(getCvsAction());
  }, []);

  
  
  const handleOpenDialog = (cv) => {
    if (cv) {
      window.open(cv.filePath, "_blank");
    }
  };

  const handleCloseDialog = () => {
    updateLead({
      name: "name",
      id: cvId,
      actionTaken: action,
    })
      .then((res) => {
        console.log(res);
        dispatch(getCvsAction());
      })
      .catch((err) => {
        console.log(err);
      });
    setDialogOpen(false);
  };

  const onUpload = () => {
    // dispatch(getCvsAction());
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };


  //advance filters

   // Step 1: State variables for each filter input field
   const [experienceYearsFilter, setExperienceYearsFilter] = useState("");
   const [gccExperienceYearsFilter, setGccExperienceYearsFilter] = useState("");
   const [sectorFilter, setSectorFilter] = useState("");
   const [occupationFilter, setOccupationFilter] = useState("");
   const [nameFilter, setNameFilter] = useState("");
   const [nicFilter, setNicFilter] = useState("");
   const [ageFilter, setAgeFilter] = useState("");
   const [selectedAgeRange, setSelectedAgeRange] = useState('');
   const [selectedAgeRangeFilter, setSelectedAgeRangeFilter] = useState({
    min: 0,
    max: 100,
   });

   const handleAgeRangeChange = (event) => {
    setSelectedAgeRange(event.target.value);

    if(event.target.value==='')
    setSelectedAgeRangeFilter({min:0,max:100});
    if(event.target.value==='1')
    setSelectedAgeRangeFilter({min:20,max:25});
    if(event.target.value==='2')
    setSelectedAgeRangeFilter({min:25,max:30});
    if(event.target.value==='3')
    setSelectedAgeRangeFilter({min:30,max:35});
    if(event.target.value==='4')
    setSelectedAgeRangeFilter({min:35,max:40});
    if(event.target.value==='5')
    setSelectedAgeRangeFilter({min:40,max:45});
    if(event.target.value==='6')
    setSelectedAgeRangeFilter({min:45,max:50});
    if(event.target.value==='7')
    setSelectedAgeRangeFilter({min:50,max:55});
    if(event.target.value==='8')
    setSelectedAgeRangeFilter({min:55,max:60});
    if(event.target.value==='9')
    setSelectedAgeRangeFilter({min:60,max:65});
    if(event.target.value==='10')
    setSelectedAgeRangeFilter({min:65,max:100});
  
    console.log(selectedAgeRangeFilter);
  };

   // Step 2: Functions to handle changes in each filter input
   const handleExperienceYearsFilterChange = (event) => {
     setExperienceYearsFilter(event.target.value);
   };
   
   const handleAgeFilterChange = (event) => {
      setAgeFilter(event.target.value);
   };

   const handleGccExperienceYearsFilterChange = (event) => {
     setGccExperienceYearsFilter(event.target.value);
   };
 
   const handleSectorFilterChange = (event) => {
     setSectorFilter(event.target.value);
   };
 
   const handleOccupationFilterChange = (event) => {
     setOccupationFilter(event.target.value);
   };


   // Step 2: State variable for storing the filtered data
  const [filteredCvs, setFilteredCvs] = useState([]);


  const calculateAge = (nic) => {
    // Extract the birth year (YY) from the NIC
    let birthYear = parseInt(nic.substr(0, 2), 10);
    
    // Check if the birth year is less than 100 (prior to 2000) or 100 or greater (from 2000 onwards)
    let fullBirthYear = birthYear < 100 ? 1900 + birthYear : 2000 + birthYear;
    
    // Get the current year
    const currentYear = new Date().getFullYear();
    
    // Calculate the age
    let age = currentYear - fullBirthYear;

    if (age>100){
      birthYear = parseInt(nic.substr(0, 4), 10);
      fullBirthYear = birthYear;
      age = currentYear - fullBirthYear;
    }
    
    return age;
  };
  const calculateAgeFromNIC = (nic) => {
    const year = nic.substring(0, 2);
    const days = parseInt(nic.substring(2, 5));
    let age = 0;
    if (days > 500) {
      age = (new Date().getFullYear() - (1900 + parseInt(year))) - 1;
    } else {
      age = new
      Date().getFullYear() - (1900 + parseInt(year));
    }
    return age;
  };
  
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
 
    // Step 3: Apply the filter logic here and update filteredCvs
    const filteredData = cvs?.filter((cv) => {
      
      const passExperienceYearsFilter =
        !experienceYearsFilter || cv?.extraField?.experienceYears >= parseInt(experienceYearsFilter);

      const passGccExperienceYearsFilter =
        !gccExperienceYearsFilter || cv?.extraField?.gcc >= parseInt(gccExperienceYearsFilter);

      const passSectorFilter =
        !sectorFilter || cv?.extraField?.sector?.toLowerCase()?.includes(sectorFilter.toLowerCase());

        const passOccupationFilter =
          !occupationFilter ||
          (typeof cv?.extraField?.occupation === 'string'
            ? cv.extraField.occupation.toLowerCase().includes(occupationFilter.toLowerCase())
            : Array.isArray(cv?.extraField?.occupation) && cv.extraField.occupation[0]?.toLowerCase().includes(occupationFilter.toLowerCase())) ||
          (typeof cv?.extraField?.occupation1 === 'string'
            ? cv.extraField.occupation1.toLowerCase().includes(occupationFilter.toLowerCase())
            : Array.isArray(cv?.extraField?.occupation1) && cv.extraField.occupation1[0]?.toLowerCase().includes(occupationFilter.toLowerCase())) ||
          (typeof cv?.extraField?.occupation2 === 'string'
            ? cv.extraField.occupation2.toLowerCase().includes(occupationFilter.toLowerCase())
            : Array.isArray(cv?.extraField?.occupation2) && cv.extraField.occupation2[0]?.toLowerCase().includes(occupationFilter.toLowerCase()));



      const nic=
        cv?.nic?.toLowerCase().includes(nicFilter.toLowerCase());

      const passNameFilter =
        !nameFilter || cv?.extraField?.name?.toLowerCase().includes(nameFilter.toLowerCase());

      let passAgeFilter = true;
      
      if(showAll){
        passAgeFilter = true;
      }else{
      
        passAgeFilter =
        !selectedAgeRangeFilter || (
          calculateAge(cv?.nic) >= selectedAgeRangeFilter.min && calculateAge(cv?.nic) <= selectedAgeRangeFilter.max
        );
      }

      return nic && passAgeFilter && passNameFilter && passExperienceYearsFilter && passGccExperienceYearsFilter && passSectorFilter && passOccupationFilter;
    });

    setFilteredCvs(filteredData);
  }, [cvs, experienceYearsFilter, gccExperienceYearsFilter, sectorFilter, occupationFilter,nameFilter,nicFilter,selectedAgeRangeFilter,filter,showAll]);

  // Step 4: Get the count of returned records
  const returnedRecordsCount = filteredCvs.length;


  //Update Dialog
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const [cvData, setCvData] = useState(null);
  const handleUpdateDialogOpen = (cv) => {
    setCvData(cv);
    setUpdateDialogOpen(true);
  };
  
  const handleCloseUpdateDialog = () => {
    setUpdateDialogOpen(false);
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    dispatch(getCvsAction());
  };


  return (
    <>
     
      <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <Tabs value={value} onChange={handleChange} centered>
        <Tab label="Short List" />
        <Tab label="Upload" />
       
      </Tabs>
    </Box>
    
    {value===0 && 

    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Analytics</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Dashboard cvs={cvs} />
        </AccordionDetails>
      </Accordion>
     

      <TableContainer component={Paper} className={customTheme.tableContainer}>
      <TextField
        label="Enter nic"
        value={nicFilter}
        size='small'
        onChange={(e) => setNicFilter(e.target.value)}
        sx={{ margin: "16px",with:'25%' }}
      />

      <TextField
        label="Enter name"
        value={nameFilter}
        size='small'
        onChange={(e) => setNameFilter(e.target.value)}
        sx={{ margin: "16px",with:'25%' }}
      />

<FormControl variant="outlined" size="small" sx={{ margin: "16px", width: '25%' }}>
  <InputLabel id="age-range-label">Age Range</InputLabel>
  <Select
    labelId="age-range-label"
    value={selectedAgeRange}
    onChange={handleAgeRangeChange}
    label="Age Range"
  >
    <MenuItem value="">
      Select an age range
    </MenuItem>
    <MenuItem value='1'>20-25</MenuItem>
    <MenuItem value='2'>25-30</MenuItem>
    <MenuItem value='3'>30-35</MenuItem>
    <MenuItem value='4'>35-40</MenuItem>
    <MenuItem value='5'>40-45</MenuItem>
    <MenuItem value='6'>45-50</MenuItem>
    <MenuItem value='7'>50-55</MenuItem>
    <MenuItem value='8'>55-60</MenuItem>
    <MenuItem value='9'>60-65</MenuItem>
    <MenuItem value='10'>65 + </MenuItem>
    {/* Add more age range options as needed */}
  </Select>
</FormControl>


     
       <TextField
        label="Experience Minimum Years"
        value={experienceYearsFilter}
        onChange={handleExperienceYearsFilterChange}
        size="small"
        sx={{ margin: "16px" }}
      />
      <TextField
        label="GCC Experience Minimum Years"
        value={gccExperienceYearsFilter}
        onChange={handleGccExperienceYearsFilterChange}
        size="small"
        sx={{ margin: "16px" }}
      />
      <TextField
        label="Sector"
        value={sectorFilter}
        onChange={handleSectorFilterChange}
        size="small"
        sx={{ margin: "16px" }}
      />
      <TextField
        label="Occupation"
        value={occupationFilter}
        onChange={handleOccupationFilterChange}
        size="small"
        sx={{ margin: "16px" }}
      />

        
<FormControlLabel
      control={
        <Checkbox
          checked={showAll}
          onChange={(e) => setShowAll(!showAll)}
          sx={{ margin: "16px" }}
          inputProps={{ 'aria-label': 'controlled' }}
        />
      }
      label="Show All" // This is the label for the Checkbox
    />

      <Typography variant="body1" sx={{ margin: "16px" }}>
        Filtered Candidates: {returnedRecordsCount}
      </Typography>
        <Table aria-label="cvs table">
          <TableHead style={{
            fontSize:'8px'
          }}>
            <TableRow>
            <TableCell style={{
                border:'1px solid #0089C4',background:'white'
              }} align="left">Candidate Name</TableCell>
             
              <TableCell style={{
                border:'1px solid #0089C4',background:'white'
              }} align="left">
                Occupation
              </TableCell>
              <TableCell style={{
                border:'1px solid #0089C4',background:'white'
              }} align="left">
                Industry Sector
              </TableCell>
              <TableCell style={{
                border:'1px solid #0089C4',background:'white'
              }} align="left">
                Age
              </TableCell>
              <TableCell style={{
                border:'1px solid #0089C4',background:'white'
              }} align="left">
                Experience years
              </TableCell>
              <TableCell style={{
                border:'1px solid #0089C4',background:'white'
              }} align="left">
                GCC Experience years
              </TableCell>
              <TableCell style={{
                border:'1px solid #0089C4',background:'white'
              }} align="left">
                UploadedBy & Remark
              </TableCell>
              <TableCell className={customTheme.tableHeadCell} align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredCvs?.map((cv) => {
              return (

                <TableRow
                  key={cv.id}
                  className={customTheme.tableRow}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                   <TableCell component='th' scope='row' style={{
                border:'1px solid #0089C4',padding:1
              }} align="left">
                    {cv.extraField.name}
                    <br />
                    <span style={{ fontSize: "0.8rem", color: "#888" }}>
                    {cv?.nic}
                      {cv.date} {cv.time}
                    </span>
                  </TableCell>
                  <TableCell style={{ border: '1px solid #0089C4' }} align="left">
                    {cv?.extraField?.occupation} <br></br>
                    {cv?.extraField?.occupation1 && 
                    cv?.extraField?.occupation1
                    }<br></br>
                    {cv?.extraField?.occupation2 &&
                    cv?.extraField?.occupation2
                    }
                  </TableCell>
                  <TableCell style={{
                border:'1px solid #0089C4',
              }} align="left">{cv?.extraField?.sector}</TableCell>
                   <TableCell style={{
                border:'1px solid #0089C4',
              }} align="left">{cv?.extraField?.age}</TableCell>
                   <TableCell style={{
                border:'1px solid #0089C4',
              }} align="left">{cv?.extraField?.experienceYears}</TableCell>
                   <TableCell style={{
                border:'1px solid #0089C4',
              }} align="left">{cv?.extraField?.gcc}</TableCell>
                   <TableCell style={{
                border:'1px solid #0089C4',
              }} align="left">
                {cv?.Employee.name} <br></br>
                {cv?.extraField?.remark }
                </TableCell>
                   <TableCell style={{
                border:'1px solid #0089C4',
              }} align="left">
                    <Button style={{margin:2,fontSize:8}} variant="contained" onClick={() => handleOpenDialog(cv)}>
                      View
                    </Button>
                    <Button style={{margin:2,fontSize:8}} variant="contained" onClick={() => handleUpdateDialogOpen(cv)}>
                      Update
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </>
    }
   
      {/* Dialog Box */}
      <Dialog sx={{ left: "10%" }} maxWidth="md" open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>What action did you take?</DialogTitle>
        <DialogContent>
          {/* Content inside the dialog */}
          <Typography variant="body1"></Typography>
          <TextField name="action" label="Action" onChange={(e) => setAction(e.target.value)} />
        </DialogContent>
        <DialogActions>
          {/* Action buttons inside the dialog */}
          <Button size="small" onClick={() => setDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button size="small" onClick={handleCloseDialog} color="primary" variant="contained">
            Update
          </Button>
        </DialogActions>
      </Dialog>

      <div>
        <UploadCv open={uploadDialogOpen} onClose={handleCloseUploadDialog} onUpload={onUpload} />
        {cvData &&
          <UpdateCvDialog open={updateDialogOpen} onClose={handleCloseUpdateDialog} cvData={cvData} onUpload={onUpload} />
        }

      </div>
    </>
  );
};

export default Cvs;